import { render, staticRenderFns } from "./formImages.vue?vue&type=template&id=2880ea4e&scoped=true"
import script from "./formImages.vue?vue&type=script&lang=js"
export * from "./formImages.vue?vue&type=script&lang=js"
import style0 from "./formImages.vue?vue&type=style&index=0&id=2880ea4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880ea4e",
  null
  
)

export default component.exports